// @ts-check

import angular from 'angular';
import * as googleAnalytics from 'google-analytics';
import * as cartCore from 'cart-core';

var RelivConferenceOrderService = /** @type {angular.IControllerConstructor} */ (function (
    relivConferenceTicketItemConverter,
    relivConferenceOrderItemConverter,
    /** @type {cartCore.CartOrderManager} */ orderMgr,
    rcmApiLibService
) {

    /**
     * self
     */
    var self = this;

    var onApiSuccess = function (response) {

    };

    var onApiError = function (response) {

    };

    /**
     * onUpdateItemsSuccess
     * @param {cartCore.CartOrderUpdateHttpResponse} response
     * @param callback
     */
    var onUpdateItemsSuccess = function (response, callback) {

        if (typeof callback === 'function') {
            var conferenceItems = relivConferenceOrderItemConverter.convertToTicketItems(
                response.data.items
            );
            callback(conferenceItems, orderMgr.messages);
        }
    };

    /**
     * onUpdateItemsError
     * @param {cartCore.CartOrderUpdateHttpResponse} response
     * @param callback
     */
    var onUpdateItemsError = function (
        response,
        callback
    ) {
        if (typeof callback === 'function') {
            callback(response);
        }
        //console.error('An error occurred', response);
    };

    /**
     * getOrderConferenceItems
     * @param conferenceItems
     * @param onComplete
     * @returns {*}
     */
    self.getOrderConferenceItems = function (
        conferenceItems,
        onComplete
    ) {
        var order = orderMgr.getOrder();

        conferenceItems = relivConferenceOrderItemConverter.convertToTicketItems(
            order.items
        );

        if (typeof onComplete === 'function') {
            onComplete(conferenceItems, orderMgr.messages);
        }
        return conferenceItems;
    };

    /**
     * updateOrderConferenceItems
     * @param conferenceItems
     * @param onSuccess
     * @param onError
     * @returns {Promise}
     */
    self.updateOrderConferenceItems = function (
        conferenceItems,
        onSuccess,
        onError
    ) {
        var order = orderMgr.getOrder();

        /** @type {cartCore.CartOrderItem[]} */
        var orderItems = relivConferenceTicketItemConverter.updateOrderItems(
            order.items,
            conferenceItems
        );

        var messages = self.validateconferenceItems(conferenceItems);

        if (messages.length > 0) {
            var response = {
                data: null,
                messages: messages,
            };

            onUpdateItemsError(response, onError);
            return;
        }

        return orderMgr.setItems(orderItems).then(
            (response) => void onUpdateItemsSuccess(response, onSuccess),
            (response) => void onUpdateItemsError(response, onError)
        );
    };

    /**
     *
     * @param conferenceItems
     */
    self.validateconferenceItems = function (conferenceItems) {

        var messages = [];

        angular.forEach(
            conferenceItems,
            function (conferenceItem, key) {
                if (!conferenceItem.conferenceId) {
                    var message = {
                        code: 'isEmpty',
                        key: 'validatorMessage.' + conferenceItem.uid + '-conferenceId.isEmpty',
                        params: [],
                        primary: null,
                        source: conferenceItem.uid + '-conferenceId',
                        type: 'validatorMessage',
                        value: "Conference is required and can't be empty",
                    };
                    messages.push(message);
                }

                if (!conferenceItem.skuNumber) {
                    var message = {
                        code: 'isEmpty',
                        key: 'validatorMessage.' + conferenceItem.uid + '-skuNumber.isEmpty',
                        params: [],
                        primary: null,
                        source: conferenceItem.uid + '-skuNumber',
                        type: 'validatorMessage',
                        value: "Ticket type is required and can't be empty",
                    };
                    messages.push(message);
                }

                if (!conferenceItem.firstName) {
                    var message = {
                        code: 'isEmpty',
                        key: 'validatorMessage.' + conferenceItem.uid + '-firstName.isEmpty',
                        params: [],
                        primary: null,
                        source: conferenceItem.uid + '-firstName',
                        type: 'validatorMessage',
                        value: "First name type is required and can't be empty",
                    };
                    messages.push(message);
                }

                if (!conferenceItem.lastName) {
                    var message = {
                        code: 'isEmpty',
                        key: 'validatorMessage.' + conferenceItem.uid + '-lastName.isEmpty',
                        params: [],
                        primary: null,
                        source: conferenceItem.uid + '-lastName',
                        type: 'validatorMessage',
                        value: "Last name type is required and can't be empty",
                    };
                    messages.push(message);
                }

                if (!conferenceItem.displayName) {
                    var message = {
                        code: 'isEmpty',
                        key: 'validatorMessage.' + conferenceItem.uid + '-displayName.isEmpty',
                        params: [],
                        primary: null,
                        source: conferenceItem.uid + '-displayName',
                        type: 'validatorMessage',
                        value: "Name on badge type is required and can't be empty",
                    };
                    messages.push(message);
                }

                if (!conferenceItem.city) {
                    var message = {
                        code: 'isEmpty',
                        key: 'validatorMessage.' + conferenceItem.uid + '-city.isEmpty',
                        params: [],
                        primary: null,
                        source: conferenceItem.uid + '-city',
                        type: 'validatorMessage',
                        value: "City type is required and can't be empty",
                    };
                    messages.push(message);
                }

                if (!conferenceItem.stateCountry) {
                    var message = {
                        code: 'isEmpty',
                        key: 'validatorMessage.' + conferenceItem.uid + '-stateCountry.isEmpty',
                        params: [],
                        primary: null,
                        source: conferenceItem.uid + '-stateCountry',
                        type: 'validatorMessage',
                        value: "State or Country type is required and can't be empty",
                    };
                    messages.push(message);
                }
            }
        );

        if (messages.length > 0) {
            var pmessages = [
                {
                    'type': 'inputFilter',
                    'source': 'validation',
                    'code': 'error',
                    'value': 'Some information was missing or invalid on the form. Please check the form and try again.',
                    'primary': true,
                    'params': [],
                    'key': 'inputFilter.validation.error',
                },
            ];
            messages = pmessages.concat(messages);
        }

        return messages;
    };

    /**
     * getCurrentUser
     * @param onSuccess
     * @param onError
     */
    self.getCurrentUser = async function (onSuccess, onError) {
        /**
         * @TODO This causes the order api to be called one more time
         * than necessary. It would be better to wait till the order
         * naturally exists rather than forcing a refresh order.
         */
        const order = await orderMgr.refreshOrder(orderMgr.loadingListener);
        if (order.data.attributes.currentUserRules.loggedIn) {
            var url = '/api/rcm-user/user/current';
            rcmApiLibService.get(
                {
                    url: url,
                    success: function (response) {
                        onApiSuccess(response);
                        onSuccess(response);
                    },
                    error: function (response) {
                        onApiError(response);
                        onError(response);
                    },
                }
            );
        }
    };

    /**
     * addFeature
     * @param ticketItem
     * @param feature
     * @param success
     * @param error
     */
    self.addFeature = function (
        ticketItem,
        feature,
        success,
        error
    ) {
        // @todo this does not deal with multiple items of same sku in cart
        /** @type {cartCore.CartOrderItem} */
        var featureOrderItem = relivConferenceTicketItemConverter.buildFeatureOrderItem(
            ticketItem,
            feature
        );

        orderMgr.updateItem(
            featureOrderItem,
            { cart_update_method: googleAnalytics.GtagCartUpdateMethod.CONFERENCE }
        ).then(success, error);
    };

    /**
     * addFeatures
     * @param ticketItem
     * @param features
     * @param success
     * @param error
     */
    self.addFeatures = function (
        ticketItem,
        features,
        success,
        error
    ) {
        var featureOrderItems = relivConferenceTicketItemConverter.buildFeatureOrderItemsFromFeatureArray(
            ticketItem,
            features,
            []
        );

        return orderMgr.setItems(
            featureOrderItems,
        ).then(success, error);
    };
});

/**
 * relivConference.relivConferenceOrderService
 */
angular.module('relivConference').service(
    'relivConferenceOrderService',
    [
        'relivConferenceTicketItemConverter',
        'relivConferenceOrderItemConverter',
        'orderMgr',
        'rcmApiLibService',
        function (
            relivConferenceTicketItemConverter,
            relivConferenceOrderItemConverter,
            orderMgr,
            rcmApiLibService
        ) {
            return new (/** @type {new (...args: any[]) => any} */ (RelivConferenceOrderService))(
                relivConferenceTicketItemConverter,
                relivConferenceOrderItemConverter,
                orderMgr,
                rcmApiLibService
            );
        },
    ]
);
